import { PureComponent, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { isBrowser, isTablet } from 'react-device-detect';
import { Formik } from 'formik';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';

import {
  Button,
  Checkbox,
  Dropdown,
  Form,
  Icon,
  Label,
  Message,
  Modal,
  Radio,
  Search,
  Segment,
} from 'semantic-ui-react';

import { assign, debounce, isEmpty, map, get } from '../../../../utils/lodash';

import {
  CustomSegment,
  CustomTable,
  EmptyContainer,
} from '../../../../components';

import {
  createNewUsers,
  updateFromSuperAdminUserType,
  resetUserPasswordAdmin,
  updateUserInfo,
  updateGuestUserInfo,
  getAllUsersOrg,
  exportSelectedUser,
  deleteUser,
  getUserActivitiesCount,
  getAllOrganisations,
  loginAsUser,
  getUserProfile,
} from '../../../../store/actions';

import { userAuthMgr } from '../../../../utils/auth';
import { stopPropagation } from '../../../../utils';
import { authMsg } from '../../../../utils/auth';
import { WithdrawUserConfirmationModal } from '../../../organization/forms/manageUsers/WithdrawUserConfirmationModal';
import PasswordChange from '../../../../components/passwordChange';

import {
  CustomCheckbox,
  CustomInput,
  CustomPasswordInput,
} from '../../../../components/form';

import {
  addNewUserByAdminInitialValues,
  addNewUserByAdminValidationSchema,
} from '../../../../validations/addNewUserByAdminValidation';

class ParentUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      search: {
        keyword: '',
        organisationId: null,
      },
      disabled: 'active',
    };
  }

  async componentDidMount() {
    const { getAllOrganisations } = this.props;

    await getAllOrganisations();
  }

  async onClickUsersExport() {
    const { search } = this.state;
    await this.props.exportSelectedUser(search);
    const { selectedUserCsvLink } = this.props;

    if (!isEmpty(selectedUserCsvLink)) {
      window.open(selectedUserCsvLink.download_link, '_blank');
    }
  }

  handleSearchChange = async (e, { value }) => {
    await this.setState((preState) => {
      return {
        ...preState,
        currentPage: 1,
        search: { ...preState.search, keyword: value },
      };
    });

    const { getAllUsersOrg } = this.props;
    const { currentPage, search, disabled } = this.state;

    getAllUsersOrg(currentPage, search, disabled);
  };

  setFilterDisabled(disabled) {
    this.setState(
      {
        disabled,
        currentPage: 1,
      },
      async () => {
        const { getAllUsersOrg } = this.props;
        const { currentPage, search, disabled } = this.state;
        await getAllUsersOrg(currentPage, search, disabled);
      }
    );
  }

  async onChangeOrganisation(event, data) {
    await this.setState((preState) => {
      return {
        ...preState,
        currentPage: 1,
        search: { ...preState.search, organisationId: data.value },
      };
    });

    const { getAllUsersOrg } = this.props;
    const { currentPage, search, disabled } = this.state;

    getAllUsersOrg(currentPage, search, disabled);
  }

  pageChange = async (page) => {
    await this.setState({ currentPage: page });

    const { getAllUsersOrg } = this.props;
    const { currentPage, search, disabled } = this.state;

    getAllUsersOrg(currentPage, search, disabled);
  };

  resetPage = () => {
    this.setState({ currentPage: 1 });
  };

  render() {
    const { currentPage, disabled } = this.state;
    const { t } = this.props;
    return (
      <div>
        <CustomSegment
          title={t('admin.user_organisation.users.manage_users')}
          className="manage-users"
          children={
            <Users
              handleSearchChange={(e, value) =>
                this.handleSearchChange(e, value)
              }
              search={this.state.search}
              onChangeOrganisation={(event, data) =>
                this.onChangeOrganisation(event, data)
              }
              setFilterDisabled={(disabled) => this.setFilterDisabled(disabled)}
              currentPage={currentPage}
              disabled={disabled}
              pageChange={this.pageChange}
              resetPage={this.resetPage}
              {...this.props}
            />
          }
          rightHeader={
            <div className="export-dropdown-btn">
              <Button size="small" className="Primary-Button">
                <Dropdown
                  text={t('actions.export')}
                  direction="left"
                  icon="angle down"
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      text={t(
                        'admin.user_organisation.users.download_takso_users'
                      )}
                      onClick={() => this.onClickUsersExport()}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </Button>
            </div>
          }
        />
        {/* TODO:  this feature will be enabled in future card */}
        {/* <div className="mt-5">
          <CustomSegment
            title="Reassign Activities"
            className="reassign-activities"
            children={<ReassignActivity />}
          />
        </div> */}
      </div>
    );
  }
}

const setDisable_option = (t) => [
  {
    key: 'all',
    text: <b>{t('account_status.all')}</b>,
    value: 'all',
  },
  {
    key: 'active',
    text: <b>{t('account_status.active')}</b>,
    value: 'active',
  },
  {
    key: 'inactive',
    text: <b>{t('account_status.inactive')}</b>,
    value: 'inactive',
  },
];

class Users extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  renderOrganizations() {
    const { organisationsAll } = this.props.admin;
    const optionList = map(organisationsAll, (item, i) => ({
      key: item.id,
      value: item.id,
      text: item.name,
    }));
    optionList.unshift({ key: null, value: null, text: '-' });

    return optionList;
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const {
      onChangeOrganisation,
      handleSearchChange,
      setFilterDisabled,
      disabled,
      search,
      resetPage,
      t,
    } = this.props;
    const orgOptions = this.renderOrganizations();

    return (
      <div>
        <div className="outcome-admin-users">
          <div className="user-search-admin">
            <div className="org-search">
              <label>{t('formulary.placeholder.select_organisation')}</label>
              <Dropdown
                className="dropdown-org-user"
                placeholder={t('formulary.placeholder.select_organisation')}
                fluid
                search
                selection
                onChange={(event, data) => onChangeOrganisation(event, data)}
                options={orgOptions}
              />
            </div>
            <div className="search-bar-user">
              <label>{t('admin.user_organisation.users.search_by_user')}</label>
              <Search
                onSearchChange={debounce(handleSearchChange, 1000, {
                  leading: true,
                })}
                value={search.value}
                placeholder={t('admin.user_organisation.users.search_by_user')}
              />
            </div>
            <div className="org-search">
              <label>{t('formulary.status')}</label>
              <Dropdown
                className="dropdown-org-user"
                placeholder={t('formulary.placeholder.select_status')}
                fluid
                search
                selection
                options={setDisable_option(t)}
                value={disabled}
                onChange={(event, { value }) => {
                  const selectedOption = setDisable_option(t).find(
                    (option) => option.value === value
                  );
                  if (selectedOption) {
                    setFilterDisabled(selectedOption.value);
                  }
                }}
              />
            </div>
          </div>
          <div className="button-outcome">
            <Modal
              open={modal}
              onOpen={() => this.toggle()}
              closeIcon={
                <Icon
                  onClick={() => this.toggle()}
                  name="close"
                  className="closeicon"
                />
              }
              size="small"
              trigger={
                <Button className="Primary-Button">
                  <div className="add-icon-activity-add">
                    <Icon name="plus circle" />
                    <div className="add-text">
                      {t('specific_actions.add_user')}
                    </div>
                  </div>
                </Button>
              }
              className="add-new-user"
            >
              <Modal.Header>{t('specific_actions.add_user')}</Modal.Header>
              <Modal.Content>
                <AddNewUser toggle={() => this.toggle()} {...this.props} />
              </Modal.Content>
            </Modal>
          </div>
        </div>
        <UsersList resetPage={resetPage} {...this.props} />
      </div>
    );
  }
}

class AddNewUser extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isShownPass: false,
      isTaksoAdminEmail: false,
    };
  }

  handleValidSubmit(values) {
    try {
      const { isTaksoAdminEmail } = this.state;
      const { createNewUsers, toggle, resetPage } = this.props;
      if (Object.keys(values).includes('confirmPassword')) {
        delete values.confirmPassword;
      }

      values.isTaksoAdminEmail = isTaksoAdminEmail;
      createNewUsers(values);

      if (resetPage) resetPage();
      toggle();
    } catch (error) {
      console.error('AddNewUser ~ handleValidSubmit ~ error', error);
    }
  }

  getOrganizations() {
    const { organisationsAll } = this.props.admin;
    return map(organisationsAll, (item, i) => ({
      key: item.id,
      value: item.id,
      text: item.name,
    }));
  }

  setIsTaksoAdminEmail() {
    this.setState((prevState) => ({
      isTaksoAdminEmail: !prevState.isTaksoAdminEmail,
    }));
  }

  render() {
    const { toggle, t } = this.props;
    const { isShownPass, isTaksoAdminEmail } = this.state;

    const { userPostLoading } = this.props.admin;

    return (
      <Formik
        initialValues={addNewUserByAdminInitialValues()}
        onSubmit={(values) => {
          this.handleValidSubmit(values);
        }}
        validationSchema={addNewUserByAdminValidationSchema(
          t,
          isTaksoAdminEmail
        )}
      >
        {({ handleSubmit, isSubmitting, setFieldValue, errors }) => (
          <Form onSubmit={handleSubmit}>
            <CustomInput
              name="firstName"
              id="firstName"
              labelText={t('formulary.first_name')}
              placeholder={t('formulary.placeholder.enter_first_name')}
              required
            />

            <CustomInput
              name="surname"
              id="surname"
              labelText={t('formulary.surname')}
              placeholder={t('formulary.placeholder.enter_surname')}
              required
            />

            <CustomCheckbox
              className="check-box"
              id="isTaksoAdminEmail"
              name="isTaksoAdminEmail"
              label={t('admin.user_organisation.users.takso_support_email')}
              checked={isTaksoAdminEmail}
              onChange={() => this.setIsTaksoAdminEmail()}
            />

            <CustomInput
              name="email"
              id="email"
              labelText={t('formulary.email')}
              placeholder={t('formulary.placeholder.enter_email')}
              required
            />

            <div>
              {' '}
              <label>{t('common.organisation')}</label>
              <Dropdown
                onChange={
                  (event, data) => setFieldValue('organisationId', data.value)
                  // this.onChangeOrganization(event, data)
                }
                className="org-inputs"
                placeholder={t('formulary.placeholder.select_organisation')}
                fluid
                search
                selection
                options={this.getOrganizations()}
              />
              <p className="formik-error-msg">
                {' '}
                {errors.organisationId && errors.organisationId}
              </p>
            </div>

            {isTaksoAdminEmail && (
              <>
                {' '}
                <CustomPasswordInput
                  id="password"
                  name="password"
                  labelText={t('formulary.new_password')}
                  placeholder={t('formulary.placeholder.enter_new_password')}
                />
                <CustomInput
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder={t('formulary.placeholder.confirm_password')}
                  labelText={t('formulary.placeholder.enter_confirm_password')}
                  type={isShownPass ? 'text' : 'password'}
                  icon={
                    <Icon
                      name={isShownPass ? 'eye' : 'eye slash'}
                      onClick={() => {
                        this.setState({ isShownPass: !isShownPass });
                      }}
                      link
                    />
                  }
                />
              </>
            )}

            <CustomInput
              name="positionTitle"
              id="positionTitle"
              labelText={t('formulary.position_designation')}
              placeholder={t(
                'formulary.placeholder.enter_position_designation'
              )}
            />
            <CustomInput
              name="phone"
              id="phone"
              labelText={t('formulary.phone')}
              placeholder={t('formulary.placeholder.enter_phone')}
            />
            <div className="model-buttons">
              <Button
                className="modal-cancel"
                size="small"
                type="button"
                onClick={() => this.toggle()}
              >
                {t('actions.cancel')}
              </Button>
              <Button
                content={t('actions.create')}
                type="submit"
                className="modal-proceed"
                loading={userPostLoading}
                disabled={userPostLoading}
              />
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

class UsersList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      doneLoginAs: false,
      checked: false,
      withdrawUserConfirmationModal: false,
      selectedUser: {},
    };
  }

  async doLoginAs(id) {
    try {
      const { loginAsUser, getUserProfile } = this.props;
      await loginAsUser(id);
      await userAuthMgr.authenticate();
      await getUserProfile();
      this.setState({ doneLoginAs: true });
    } catch (error) {
      console.error('LOGIN AS ~ error', error);
    }
  }

  renderColumns() {
    const { t } = this.props;

    return [
      {
        title: (
          <div className="user-heading-container">
            <strong>{t('formulary.name')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className="user-name-badge">
              <div
                className={
                  data.disabled ? 'venue-name-disabled' : 'org-users-container'
                }
              >
                <span className="org-users-cdn-container">
                  <label className="org-users-mainText">{data.name}</label>
                </span>
              </div>
              <label className="org-users-text">
                {data.disabled ? (
                  <Label className="user-badge" color="red" size="tiny">
                    {t('common.disabled')}
                  </Label>
                ) : null}
                <Label className="user-badge" color="orange" size="tiny">
                  {this.renderUserType(data.role)}
                </Label>
                {String(data.email).includes('cdn-admin@') ? (
                  <Label color="grey" size="tiny" basic>
                    {t('common.cdn_admin')}
                  </Label>
                ) : null}
              </label>
            </div>
          );
        },
      },
      {
        title: (
          <div className="user-heading-container">
            <strong>{t('formulary.email')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div
              className={
                data.disabled ? 'venue-name-disabled' : 'org-users-container'
              }
            >
              {data.email}
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        title: (
          <div className="user-heading-container">
            <strong>{t('common.organisation')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div
              className={
                data.disabled ? 'venue-name-disabled' : 'org-users-container'
              }
            >
              {get(data, 'organisation.name', '-')}
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        render: (data) => {
          const { userActivities } = this.props;
          return (
            <div className="remove-user">
              <UserDelete
                user={data}
                {...this.props}
                withdrawUserConfirmationModalHandler={(status, user) =>
                  this.withdrawUserConfirmationModalHandler(status, user)
                }
              />
              <WithdrawUserConfirmationModal
                isAdmin
                user={this.state.selectedUser}
                userActivities={userActivities}
                // {...this.props}
                resetPage={() => this.props.resetPage()}
                modal={this.state.withdrawUserConfirmationModal}
                handleModal={(status) =>
                  this.withdrawUserConfirmationModalHandler(status)
                }
              />
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'left' : null,
      },
      {
        render: (data) => {
          return (
            <div className="owned">
              {this.state.doneLoginAs ? (
                <Navigate to="/activities" replace={true} />
              ) : null}
              <Dropdown
                icon="ellipsis vertical"
                direction="left"
                inline
                selectOnBlur={false}
              >
                <Dropdown.Menu>
                  {!data.disabled ? (
                    <Dropdown.Item
                      text={`${t('common.login_as')}...`}
                      className="dropdown-customItem"
                    >
                      <span
                        className="login-as"
                        onClick={(e) => this.doLoginAs(data.id)}
                      >
                        {t('admin.users.login_as_id', { id: data.id })}
                      </span>
                    </Dropdown.Item>
                  ) : null}

                  <EditUser data={data} {...this.props} />

                  <UserPassChange user={data} {...this.props} />

                  {data.organisationId && (
                    <UserTypeChange
                      user={data}
                      {...this.props}
                      {...this.props}
                    />
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
        textAlign: isBrowser || isTablet ? 'center' : null,
      },
    ];
  }

  withdrawUserConfirmationModalHandler(status, selectedUser) {
    this.setState({ withdrawUserConfirmationModal: status, selectedUser });
  }

  renderUserType(role) {
    const { t } = this.props;

    switch (role) {
      case 'organisationAdmin':
        return t('role.organisation_admin');
      case 'user':
        return t('role.user');
      case 'guest':
        return t('role.guest');
      case 'admin':
        return t('role.super_admin');
      default:
        break;
    }
  }

  async componentDidMount() {
    try {
      const { getAllUsersOrg, currentPage } = this.props;
      await getAllUsersOrg(currentPage);
    } catch (error) {
      console.error('UsersList ~ componentDidMount ~ error', error);
    }
  }

  render() {
    const {
      admin: { allUserList, orgAllLoading },
      currentPage,
      t,
    } = this.props;

    return (
      <Segment
        className="content-segment-users"
        loading={orgAllLoading}
        disabled={orgAllLoading}
      >
        {allUserList.docs ? (
          <CustomTable
            header
            columns={this.renderColumns()}
            data={allUserList.docs}
            pagination
            handlePaginationChange={(page) => this.props.pageChange(page)}
            customClass="super-admin-table tbody-hover"
            page={currentPage}
            noOfPages={allUserList.pages}
            keyExtractor={(item, index) => item.id}
          />
        ) : (
          <EmptyContainer msg={t('admin.user_organisation.users.no_users')} />
        )}
      </Segment>
    );
  }
}

class UserPassChange extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { user, t } = this.props;
    return (
      <div className="add-user">
        <Modal
          trigger={
            <Dropdown.Item>
              <label className="edit-org">
                {t('admin.user_organisation.users.reset_password')}
                <Icon name="write" />
              </label>
            </Dropdown.Item>
          }
          size="tiny"
          open={modal}
          onOpen={() => this.toggle()}
          onClick={(e) => stopPropagation(e)}
          onFocus={(e) => stopPropagation(e)}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
        >
          <Modal.Header>
            {t('admin.user_organisation.users.reset_password')} - {user.name}
          </Modal.Header>
          <Modal.Content>
            <PassChangeForm toggle={() => this.toggle()} {...this.props} />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}
class PassChangeForm extends Component {
  handleValidSubmit(values) {
    try {
      const { user, toggle, resetUserPasswordAdmin } = this.props;

      const form = assign(user, values);

      resetUserPasswordAdmin(form);

      this.form && this.form.reset();
      toggle();
    } catch (error) {
      console.error('PassChangeForm ~ handleValidSubmit ~ error', error);
    }
  }

  render() {
    const { toggle } = this.props;
    return (
      <PasswordChange
        toggle={() => toggle()}
        handleValidSubmit={(values) => {
          this.handleValidSubmit(values);
        }}
      />
    );
  }
}

class EditUser extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        firstName: '',
        surName: '',
        positionTitle: '',
        phone: '',
        email: '',
        isTaksoAdminEmail: false,
        organisationId: '',
      },
    };
  }

  editUser(form) {
    form.phone = form.phone ? form.phone.replace(/\D/g, '') : '';
    this.setState({
      form,
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }
  render() {
    const { modal, form } = this.state;
    const { data, t } = this.props;

    return (
      <div>
        <div className="button-outcome">
          <Modal
            open={modal}
            onOpen={() => this.toggle()}
            onClick={(e) => stopPropagation(e)}
            onFocus={(e) => stopPropagation(e)}
            closeIcon={
              <Icon
                onClick={() => this.toggle()}
                name="close"
                className="closeicon"
              />
            }
            size="small"
            trigger={
              <Dropdown.Item>
                <label className="edit-org" onClick={() => this.editUser(data)}>
                  {t('admin.user_organisation.users.edit_organisation')}
                  <Icon name="write" />
                </label>
              </Dropdown.Item>
            }
          >
            <Modal.Header>
              {t('admin.user_organisation.users.edit_user')}
            </Modal.Header>
            <Modal.Content>
              <EditUserModalForm
                form={form}
                toggle={() => this.toggle()}
                {...this.props}
              />
            </Modal.Content>
          </Modal>
        </div>
      </div>
    );
  }
}

class EditUserModalForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      organisationId: '',
      disabled: !get(this.props, 'form.organisation.isActive', true),
      isTaksoAdminEmail: get(this.props, 'form.isTaksoAdminEmail', false),
    };
  }

  async handleValidSubmit(event, values) {
    try {
      const {
        form,
        toggle,
        updateUserInfo,
        updateGuestUserInfo,
        resetPage,
        currentPage,
      } = this.props;
      const { disabled, isTaksoAdminEmail } = this.state;
      values.disabled = disabled;
      values.isTaksoAdminEmail = isTaksoAdminEmail;

      form.organisation !== null
        ? await updateUserInfo(
            form.organisation.id,
            form.id,
            values,
            currentPage
          )
        : await updateGuestUserInfo(form.id, values, currentPage);

      if (resetPage) resetPage();
      toggle();
    } catch (error) {
      console.error('EditUserModalForm ~ handleValidSubmit ~ error', error);
    }
  }

  toggleCheckbox() {
    this.setState((prevState) => {
      return { disabled: !prevState.disabled };
    });
  }

  componentDidMount() {
    const { form } = this.props;
    this.setState({ disabled: Boolean(form.disabled) });
  }

  setIsTaksoAdminEmail() {
    this.setState((prevState) => ({
      isTaksoAdminEmail: !prevState.isTaksoAdminEmail,
    }));
  }
  render() {
    const { toggle, form, userUpdateLoading, t } = this.props;

    const { disabled, isTaksoAdminEmail } = this.state;

    const isGuestUser = !Boolean(get(this.props, 'form.organisationId', null));

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        model={form}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="venue-form"
      >
        <AvField
          label={t('formulary.first_name')}
          className="org-inputs"
          name="firstName"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.first_name_required'),
            },
          }}
        />
        <div className="gap-between-edit">
          <AvField
            label={t('formulary.surname')}
            className="org-inputs"
            name="surname"
            type="text"
            validate={{
              required: {
                value: true,
                errorMessage: t('formulary.validation.surname_required'),
              },
            }}
          />
        </div>

        {!isGuestUser && (
          <div className="gap-between-edit">
            <Checkbox
              className="check-box"
              id="isTaksoAdminEmail"
              name="isTaksoAdminEmail"
              label={t('formulary.takso_support_email')}
              checked={isTaksoAdminEmail}
              onChange={() => this.setIsTaksoAdminEmail()}
            />
          </div>
        )}

        <div className="gap-between-edit">
          <AvField
            label={t('common.email')}
            className="org-inputs"
            name="email"
            type="email"
            validate={{
              required: {
                value: true,
                errorMessage: t('formulary.validation.email_required'),
              },
            }}
          />
        </div>
        <div className="gap-between-edit">
          <AvField
            label={t('formulary.position_designation_optional')}
            className="org-inputs"
            name="positionTitle"
            autoComplete="off"
            type="text"
          />
        </div>
        <AvField
          label={t('formulary.phone_optional')}
          className="org-inputs"
          name="phone"
          type="number"
          validate={{
            maxLength: {
              value: 15,
              errorMessage: t(
                'formulary.validation.must_be_a_minimum_of_15_digits'
              ),
            },
          }}
        />

        <div className="edit-outcome-status-bar">
          <label>{t('common.disable')}</label>
          <div className="two-step-radio-container-admin status-left">
            <Radio
              name="isEnable"
              toggle
              className="modal-toggle"
              checked={disabled}
              onChange={() => this.toggleCheckbox()}
              disabled={!get(this.props, 'form.organisation.isActive', true)}
            />
          </div>
        </div>
        {!get(this.props, 'form.organisation.isActive', true) && (
          <div className="msg-report">
            <Message
              color="blue"
              icon="exclamation circle"
              content={t(
                'admin.user_organisation.users.the_account_associated_with_this_user_is_currently_disabled'
              )}
            />
          </div>
        )}

        <div className="model-buttons">
          <Button
            className="modal-cancel"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.save')}
            type="submit"
            className="modal-proceed"
            loading={userUpdateLoading}
            disabled={userUpdateLoading}
          />
        </div>
      </AvForm>
    );
  }
}
class UserTypeChange extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { user, t } = this.props;

    return (
      <div className="add-user">
        <Modal
          trigger={
            <Dropdown.Item>
              <label className="edit-user">
                {t('admin.user_organisation.users.change_user_type')}
                <Icon className="ml-2" name="write" />
              </label>
            </Dropdown.Item>
          }
          // trigger={<label className="user-type-change"></label>}
          size="small"
          open={modal}
          onOpen={() => this.toggle()}
          onClick={(e) => stopPropagation(e)}
          onFocus={(e) => stopPropagation(e)}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
        >
          <Modal.Header>
            {t('admin.user_organisation.users.change_user_type')} - {user.name}
          </Modal.Header>
          <Modal.Content>
            <UserTypeForm toggle={() => this.toggle()} {...this.props} />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}
class UserTypeForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleValidSubmit(event, values) {
    try {
      const { updateFromSuperAdminUserType, toggle, user, resetPage } =
        this.props;
      let form = {
        role: {},
      };
      if (values.role === 'organisationAdmin') {
        form.role.organisationAdmin = true;
      } else {
        form.role.organisationAdmin = false;
      }

      updateFromSuperAdminUserType(user.organisationId, user.id, form);
      this.form && this.form.reset();
      if (resetPage) resetPage();
      toggle();
    } catch (error) {
      console.error('UserTypeForm ~ handleValidSubmit ~ error', error);
    }
  }

  render() {
    const { toggle, user, t } = this.props;
    const defaultValue = user;
    return (
      <AvForm
        model={defaultValue}
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
      >
        <AvField
          label={t('formulary.user_type')}
          className="org-inputs"
          name="role"
          type="select"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.user_type_required'),
            },
          }}
        >
          <option value="" disabled defaultValue>
            {t('formulary.placeholder.select_an_user_type')}
          </option>
          <option value="organisationAdmin">
            {t('role.organisation_admin')}
          </option>
          <option value="user">{t('role.user')}</option>
        </AvField>
        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.update')}
            type="submit"
            className="Primary-Button"
          />
        </div>
      </AvForm>
    );
  }
}
class UserDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  async toggle() {
    const { modal } = this.state;
    const { user, getUserActivitiesCount } = this.props;
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
    !modal && (await getUserActivitiesCount(user.id));
  }

  handleDeleteOrgUser() {
    const {
      user,
      resetPage,
      withdrawUserConfirmationModalHandler,
      userActivities,
      deleteUser,
      t,
    } = this.props;
    if (
      (userActivities.inDevelopmentInvited > 0 ||
        userActivities.inActiveInvited > 0) &&
      userActivities.inDevelopmentOwned === 0 &&
      userActivities.inActiveOwned === 0
    ) {
      this.toggle();
      withdrawUserConfirmationModalHandler(true, user);
    } else {
      if (
        userActivities.inDevelopmentOwned > 0 ||
        userActivities.inActiveOwned > 0
      ) {
        authMsg(
          'error',
          t(
            'admin.user_organisation.users.user_has_active_development_activities',
            {
              count:
                userActivities.inDevelopmentOwned +
                userActivities.inActiveOwned,
            }
          )
        );
      } else {
        deleteUser(user.id);
      }
      if (resetPage) resetPage();
      this.toggle();
    }
  }

  render() {
    const { modal } = this.state;
    const { t } = this.props;
    const { userRemoveLoading } = this.props.admin;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="mini"
        trigger={
          <label className="user-remove first-down">
            {t('actions.remove')}
          </label>
        }
        className="delete-user"
      >
        <Modal.Header>
          {t('admin.user_organisation.users.delete_user')}
        </Modal.Header>
        <Modal.Content>
          <p>
            {t(
              'admin.user_organisation.users.are_you_sure_you_want_to_delete_this_user'
            )}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button className="Secondary-Button" onClick={() => this.toggle()}>
            {t('actions.no')}
          </Button>
          <Button
            onClick={() => this.handleDeleteOrgUser()}
            loading={userRemoveLoading}
            disabled={userRemoveLoading}
            className="Primary-Button"
          >
            {t('actions.yes')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization,
    admin: state.admin,
    userUpdateLoading: state.organization.userUpdateLoading,
    selectedUserCsvLink: state.admin.selectedUserCsvLink,
    userActivities: state.organization.userActivities,
    ...state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getAllUsersOrg,
      createNewUsers,
      updateFromSuperAdminUserType,
      resetUserPasswordAdmin,
      updateUserInfo,
      updateGuestUserInfo,
      deleteUser,
      exportSelectedUser,
      getUserActivitiesCount,
      getAllOrganisations,
      loginAsUser,
      getUserProfile,
    },
    dispatch
  );
};

ParentUsers = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ParentUsers));

export { ParentUsers };
